// extracted by mini-css-extract-plugin
export default {"NavItem":"NavItem_NavItem__O2Lpp","isActive":"NavItem_isActive__6nORR","swing-in":"NavItem_swing-in__1FWgU"};